import React, { useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Box, CssBaseline } from '@mui/material'
import { ThemeProvider } from './contexts/ThemeContext'
import TopNavigation from './components/Navigation/TopNavigation'
import RadialGaugePage from './pages/RadialGaugePage'
import BarChartPage from './pages/BarChartPage'
import PieChartPage from './pages/PieChartPage'
import ErrorBoundary from './components/ErrorBoundary'

const App: React.FC = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  const handleRefresh = () => {
    setRefreshTrigger((prev) => prev + 1)
  }

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <Router>
          <CssBaseline />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              minHeight: '100vh'
            }}>
            {/* Top Navigation with Refresh */}
            <TopNavigation onRefresh={handleRefresh} />

            {/* Main Content Area */}
            <Box
              component='main'
              sx={{
                flexGrow: 1,
                overflow: 'auto',
                backgroundColor: 'background.default',
                p: { xs: 1, sm: 2, md: 3 }
              }}>
              <Routes>
                <Route
                  path='/'
                  element={<RadialGaugePage key={refreshTrigger} />}
                />
                <Route
                  path='/bar-chart'
                  element={<BarChartPage key={refreshTrigger} />}
                />
                <Route
                  path='/pie-chart'
                  element={<PieChartPage key={refreshTrigger} />}
                />
              </Routes>
            </Box>
          </Box>
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  )
}

export default App
